import * as firebase from 'firebase/app';
import 'firebase/messaging';
import 'firebase/remote-config';

const firebaseConfig = {
  apiKey: process.env.FIREBASE_API_KEY,
  authDomain: process.env.FIREBASE_AUTH_DOMAIN,
  projectId: process.env.FIREBASE_PROJECT_ID,
  storageBucket: process.env.FIREBASE_STORAGE_BUCKET,
  databaseURL: process.env.FIREBASE_DATABASE_URL,
  messagingSenderId: process.env.FIREBASE_SENDER_ID,
  appId: process.env.FIREBASE_APP_ID,
};

const firebaseApp = firebase.default.initializeApp(firebaseConfig);
const isMessagingSupported = !!firebase.default?.messaging?.isSupported();

export { firebaseApp, isMessagingSupported };
